export default __webpack_public_path__ + "static/media/misc-closetA.f24132f0.jpg";